import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueI18n from 'vue-i18n';
import en from '../locale/en.ts';
import pt from '../locale/pt.ts';


Vue.use(Vuetify);
Vue.use(VueI18n);

export default new Vuetify({
  lang: {
    locales: { pt, en },
    current: 'pt',
  },
});
